import theme from 'theme'

export const DEFAULT_SELECT_MENU_PROPS = {
  disableRestoreFocus: true,
  disableEnforceFocus: true,
  PaperProps: {
    sx: {
      backgroundColor: theme.colors.borderMedium,
      transform: `translateY(${theme.spacing.xSmall}px) !important`,
      overflow: 'hidden',
      "html[data-theme='light'] &": {
        backgroundColor: theme.colors.surfaceContainerBackground,
        '& ul > .MuiBox-root::-webkit-scrollbar-thumb': {
          backgroundColor: theme.colors.borderMedium
        }
      },
      ' ul': {
        paddingTop: 0,
        paddingBottom: 0
      },
      '& .MuiMenuItem-root': {
        minHeight: '42px'
      },
      '& .MuiMenuItem-root:first-of-type': {
        minHeight: '48px'
      },
      '& .MuiFormControlLabel-label': {
        color: theme.colors.menuItemText,
        fontSize: theme.typography.fontSize.large
      },
      '& ul > .MuiBox-root': {
        maxHeight: '250px',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          width: '6px'
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: 'transparent'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: theme.colors.surfaceContainerBackground,
          borderRadius: '2px'
        }
      }
    },
    style: {
      width: 300,
      maxHeight: 300,
      borderRadius: theme.spacing.md
    }
  },
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const
  },
  variant: 'menu' as const
}
